export class AppConsts {
  static subDirectory;
  static remoteServiceBaseUrl;
  static appBaseUrl;
  static debug;
  static wechat_platform = false;
  static cp_wechat_platform = false;
  static yun_localtion = "";
  static docExtensions = [];
  static videoExtensions = [];
  static scormExtensions = [];
  static home_buttons = [];
  static home_buttonsCustomized = [];
  static home_buttons_align = "flex-start";
  static resource_buttons = [];
  static resource_buttons_align = "flex-start";
  static languageDetails = null;
  static languages = [];
  static wechat = {};
  static site = {};
  static enableCustomHome = "";
  static enableRule = "";
  static enableZYYHome = false;
  static wxUrl = "";
  static rsa_home_url = "/";
  static show_header = false;
  static page_init_by_category = false;
  static guest_mode = false;
  static show_user_rank = false;
  static show_rank = false;
  static guest_buttons = [];
  static sany = false;
  static isMobile = false;
  static company = "";
  static  reportButtons = [];
  static  dingding_platform = false;

  static currentLanguage() {
    var Language = abp.utils.getCookieValue("Language.CultureName") || "zh_CN";
    return Language;
  }

  static userManagement = {
    defaultAdminUserName: "admin"
  };

  static localization = {
    defaultLocalizationSourceName: "davco"
  };

  static authorization = {
    encrptedAuthTokenName: "enc_auth_token",
    twoFactorRememberClientTokenName: "TwoFactorRememberClientToken"
  };

  static grid = {
    defaultPageSize: 10
  };
}



// WEBPACK FOOTER //
// ./src/shared/libs/ClientFramework/packages/abpVue/AppConsts.js